/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const authorisePaymentMethodDataSchema = z.object({
	amount: z.number(),
	idempotencyToken: z.string().uuid(),
	profileId: z.string().uuid().nullable().optional(),
})

export type AuthorisePaymentMethodDataSchema = z.infer<typeof authorisePaymentMethodDataSchema>
